var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadingSlump(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 128,
    viewBox: "0 0 129 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 114.5,
    r: 12.5,
    transform: "rotate(90 64 114.5)",
    fill: "#263668"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 63.5,
    r: 12.5,
    transform: "rotate(90 115 63.5)",
    fill: "#68749D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 12.5,
    r: 12.5,
    transform: "rotate(90 64 12.5)",
    fill: "#A9B3D2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 63.5,
    r: 12.5,
    transform: "rotate(90 13 63.5)",
    fill: "#17203E"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.062,
    cy: 99.5624,
    r: 12.5,
    transform: "rotate(45 100.062 99.5624)",
    fill: "#475582"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.062,
    cy: 27.4376,
    r: 12.5,
    transform: "rotate(45 100.062 27.4376)",
    fill: "#8894B7"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.9375,
    cy: 27.4376,
    r: 12.5,
    transform: "rotate(45 27.9375 27.4376)",
    fill: "#CAD2EC"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.9375,
    cy: 99.5624,
    r: 12.5,
    transform: "rotate(45 27.9375 99.5624)",
    fill: "#1E2B53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingSlump);
export default __webpack_public_path__ + "static/media/loadingSlump.164ea7b30d2b9eabb5a6709e0406413c.svg";
export { ForwardRef as ReactComponent };